import React from "react";
import { FaPercent, FaRegSmile, FaCheckCircle } from "react-icons/fa";
import about5 from "../assets/rankridgecollegewebsiteimages 01/about5.webp"
import welcome from "../assets/rankridgecollegewebsiteimages 01/welcome.webp"
import about6 from "../assets/rankridgecollegewebsiteimages 01/about6.webp"
import about8 from "../assets/about/rankridgecollge.png"
import about9 from "../assets/about/smart.png"
import about4 from "../assets/rankridgecollegewebsiteimages 01/about4.webp"
import about2 from "../assets/about/iitjeeandneet.png"
import vision from "../assets/about/vision.png"
import students from '../assets/about/students.png'

import AboutComponent from "./rankridge_about_page";
import CommonImageSlider from "./comandata";
import { aboutImages, studentsRanks } from "./data";
import CallandRegisterComponent from "./Callbutton";
import CommonImageSliderRanks from "./CommonsliderRanks";
import SeoMeta from "./seometa/seometa";
import CommonImageSliderWithText from "./comandataimagewithtex";
import { CommonAboutHeader } from "./CommonAboutHeader";
import RankridgeHighlight from "./RankridgeHighlight";

const seoAbout = {
  title: "About Rankridge | Best Junior College for IIT JEE & NEET",
  description: "Learn about Rankridge, Hyderabad’s top junior college for IIT JEE & NEET Long Term with MPC & BiPC Intermediate. Proven results & expert mentoring.",
  keywords: "About Rankridge Junior College, Rankridge Junior College Hyderabad, Best Junior Colleges in Hyderabad, Top Intermediate Colleges in Hyderabad, MPC Junior College Hyderabad, BiPC Junior College Hyderabad, IIT JEE Foundation Junior College Hyderabad, NEET Foundation Junior College Hyderabad, Best MPC Colleges in Hyderabad, Best BiPC Colleges in Hyderabad, Junior Colleges with Hostel Facility Hyderabad, Best Residential Junior Colleges in Hyderabad, Rankridge Junior College KPHB, Top Junior Colleges Near Kukatpally, Junior Colleges Near Hitech City Hyderabad, Best Colleges for 11th and 12th in Hyderabad, Junior Colleges with Sports Facilities Hyderabad, Junior College with UPSC Coaching Hyderabad, Civils Coaching Junior College Hyderabad, Rankridge Vision and Mission, Rankridge Faculty, Rankridge Campus Facilities, Rankridge Academic Excellence, Rankridge Achievements, Junior College with IIT JEE Coaching, Junior College with NEET Coaching, Best Junior College Admissions Hyderabad",
  canonical_path: "https://www.rankridge.com/about-us/",
  og_description: "",
  og_image: "",
};

const title="About Rankridge Junior College"
 const description=`<p className="mt-4 m-4 text-justify">Welcome to Rankridge Junior College - Nurturing Bright Futures At Rankridge Junior College Hyderabad, we prepare students not only for Intermediate Board Exams (MPC & BiPC) but also for the most competitive exams like IIT-JEE, NEET & EAMCET. Known as one of the best junior colleges in Hyderabad, Rankridge has built a reputation for academic excellence, personal mentoring, and stress-free preparation. Our focus is simple: help students achieve top ranks in IIT-JEE, NEET & EAMCET while ensuring 100% success in board exams. With our unique approach, we make sure every student is ready for IITs, NITs, AIIMS, JIPMER, and top medical colleges in India.  When parents search for the “Top Junior College in Hyderabad for IIT-JEE and NEET”, Rankridge stands out because of our results, mentoring culture, and student care. <br></br> <br></br> Parents trust Rankridge because we focus not just on academics, but also on discipline, confidence, and overall personality development. From hygienic food and safe hostels to GPS-enabled buses and regular parent reviews, we create a supportive ecosystem where every child can thrive.
</p>`


export default function About() {
  return (
    <div >

 <section className=" m-1 ">
    
      {/* Right half on md+, full width on mobile */}
      <center>
      <h1  className="text-3xl justify-center text-black font-extrabold">Beyond Education – Building India’s Next 
  IITians, Doctors & Leaders. </h1>
  </center>
           <CommonAboutHeader  images={aboutImages} title={title} des={description}/>
 

      
{/* Left half on md+, full width on mobile */}
      
    </section>

 
  <div className="text-center">
<center>

</center>
</div>
   <RankridgeHighlight />
     
    
 <CommonImageSliderRanks images={studentsRanks}  />
<CallandRegisterComponent />
<SeoMeta seopages={seoAbout} />
    </div>
  );
}
